// extracted by mini-css-extract-plugin
export default {"copyrightContainer":"FooterCopyright_copyrightContainer__RDP+W","text":"FooterCopyright_text__HCwjv"};